<template>
  <div v-if="text">
    <p
      v-if="text.length > limit"
      v-tooltip.top="text"
      class="m-0"
    >
      {{ trimmedText }}
      <span class="font-weight-bolder"> ... </span>
    </p>
    <p
      v-else
      class="m-0"
    >
      {{ text }}
    </p>
  </div>
</template>

<script>
export default {
  name: "LimitedText",
  props: {
    limit: {
      type: Number,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
  },
  computed: {
    trimmedText() {
      return this.text.substring(0, this.limit);
    },
  },
};
</script>
